
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];
    
    const js_code = {
        'kotlin.captureStackTrace' : () => new Error().stack,
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => { return obj[index]; },
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => { return obj[index]; },
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.KeyboardEventInit_js_code' : (key, code, location, repeat, isComposing, ctrlKey, shiftKey, altKey, metaKey, modifierAltGraph, modifierCapsLock, modifierFn, modifierFnLock, modifierHyper, modifierNumLock, modifierScrollLock, modifierSuper, modifierSymbol, modifierSymbolLock, view, detail, bubbles, cancelable, composed) => { return { key, code, location, repeat, isComposing, ctrlKey, shiftKey, altKey, metaKey, modifierAltGraph, modifierCapsLock, modifierFn, modifierFnLock, modifierHyper, modifierNumLock, modifierScrollLock, modifierSuper, modifierSymbol, modifierSymbolLock, view, detail, bubbles, cancelable, composed }; },
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_fun' : (p0, p1, isDefault0) => new KeyboardEvent(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => { return { passive, once, capture }; },
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.dom.prompt_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.prompt(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.getElementsByTagName_$external_fun' : (_this, p0) => _this.getElementsByTagName(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.item_$external_fun_2' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.HTMLTitleElement_$external_class_instanceof' : (x) => x instanceof HTMLTitleElement,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.HTMLStyleElement_$external_class_instanceof' : (x) => x instanceof HTMLStyleElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'org.w3c.dom.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.wasm.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.wasm.GL_$external_object_getInstance' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.keyCode_$external_prop_setter' : (_this, v) => _this.keyCode = v,
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
        'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process.env.KTOR_LOG_LEVEL,
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'io.ioda.one.copyToClipboard' : function(text) { navigator.clipboard.writeText(text); },
        'io.ioda.one.auth.jsGenerateSalt' : 
        function() {
            var arr = new Uint8Array(32);
            crypto.getRandomValues(arr);
            return Array.from(arr).map(function(b) { return b.toString(16).padStart(2, '0'); }).join('');
        }
        ,
        'io.ioda.one.auth.loadAppleSDK' : 
        function() {
            return new Promise(function(resolve, reject) {
                if (window.__appleSDKLoaded) { resolve(true); return; }
                if (document.getElementById('apple-signin-script')) {
                    window.__appleSDKLoaded = true;
                    resolve(true);
                    return;
                }
                var script = document.createElement('script');
                script.id = 'apple-signin-script';
                script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
                script.async = true;
                script.onload = function() { window.__appleSDKLoaded = true; resolve(true); };
                script.onerror = function() { reject(new Error('Failed to load Apple SDK')); };
                document.head.appendChild(script);
            });
        }
        ,
        'io.ioda.one.auth.appleSignIn' : 
        function(clientId) {
            AppleID.auth.init({
                clientId: clientId,
                scope: 'name email',
                redirectURI: window.location.origin + '/login',
                usePopup: true
            });
            return AppleID.auth.signIn().then(function(response) {
                if (response && response.authorization && response.authorization.id_token) {
                    return response.authorization.id_token;
                }
                return '__CANCELLED__';
            }, function(err) {
                return '__CANCELLED__';
            });
        }
        ,
        'io.ioda.one.auth.loadGoogleGSI' : 
        function() {
            return new Promise(function(resolve, reject) {
                if (window.__googleGSILoaded) { resolve(true); return; }
                if (document.getElementById('google-gsi-script')) {
                    window.__googleGSILoaded = true;
                    resolve(true);
                    return;
                }
                var script = document.createElement('script');
                script.id = 'google-gsi-script';
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.onload = function() { window.__googleGSILoaded = true; resolve(true); };
                script.onerror = function() { reject(new Error('Failed to load Google Identity Services')); };
                document.head.appendChild(script);
            });
        }
        ,
        'io.ioda.one.auth.googleSignIn' : 
        function(clientId) {
            return new Promise(function(resolve, reject) {
                var g = window.google;
                if (!g || !g.accounts || !g.accounts.id) {
                    reject(new Error('Google Identity Services not available'));
                    return;
                }
                var resolved = false;
                var popupWindow = null;
                var cleanup = function() {
                    window.removeEventListener('focus', onFocus);
                    document.removeEventListener('visibilitychange', onVis);
                    if (window.__googlePopupCheck) {
                        clearInterval(window.__googlePopupCheck);
                        window.__googlePopupCheck = null;
                    }
                };
                var cancel = function() {
                    if (!resolved) { resolved = true; cleanup(); reject(new Error('cancelled')); }
                };
                var onFocus = function() { cancel(); };
                var onVis = function() {
                    if (document.visibilityState === 'visible') cancel();
                };
        
                g.accounts.id.initialize({
                    client_id: clientId,
                    callback: function(response) {
                        if (resolved) return;
                        resolved = true;
                        cleanup();
                        if (response.credential) {
                            resolve(response.credential);
                        } else {
                            reject(new Error('No credential received from Google'));
                        }
                    },
                    auto_select: false,
                    cancel_on_tap_outside: false
                });
        
                var usingPopup = false;
                g.accounts.id.prompt(function(notification) {
                    // One Tap dismissed by user (iframe overlay)
                    if (notification.isDismissedMoment && notification.isDismissedMoment()) {
                        var reason = notification.getDismissedReason ? notification.getDismissedReason() : '';
                        if (reason !== 'credential_returned') {
                            cancel();
                        }
                        return;
                    }
                    // One Tap not available — fall back to popup button
                    if (notification.isNotDisplayed && notification.isNotDisplayed() ||
                        notification.isSkippedMoment && notification.isSkippedMoment()) {
                        usingPopup = true;
                        var container = document.createElement('div');
                        container.style.position = 'fixed';
                        container.style.top = '-9999px';
                        document.body.appendChild(container);
                        g.accounts.id.renderButton(container, {
                            type: 'standard', size: 'large', theme: 'filled_black'
                        });
                        var btn = container.querySelector('div[role=button]');
                        if (btn) {
                            // Intercept window.open to track the popup
                            var origOpen = window.open;
                            window.open = function() {
                                var w = origOpen.apply(window, arguments);
                                if (w) {
                                    popupWindow = w;
                                    // Poll for popup close
                                    window.__googlePopupCheck = setInterval(function() {
                                        if (popupWindow && popupWindow.closed) {
                                            cancel();
                                        }
                                    }, 300);
                                }
                                window.open = origOpen; // restore immediately
                                return w;
                            };
                            btn.click();
                            // Restore open if popup didn't fire
                            requestAnimationFrame(function() { window.open = origOpen; });
                            // Also listen for focus as backup
                            window.addEventListener('focus', onFocus);
                            document.addEventListener('visibilitychange', onVis);
                        } else {
                            cancel();
                        }
                        // Remove container after a frame (button already clicked)
                        requestAnimationFrame(function() { container.remove(); });
                    }
                });
            });
        }
        ,
        'io.ioda.one.jsSentryCaptureException' : 
            function(message, contextJson) {
                if (typeof window === 'undefined' || !window.Sentry) return;
                try {
                    var ctx = contextJson ? JSON.parse(contextJson) : null;
                    // Wrap the string into an Error so Sentry treats it as an exception with stack
                    var err = new Error(message);
                    if (ctx) {
                        window.Sentry.captureException(err, { tags: ctx });
                    } else {
                        window.Sentry.captureException(err);
                    }
                } catch (e) {}
            }
            ,
        'io.ioda.one.jsSentrySetUser' : 
            function(id, username, walletAddress) {
                if (typeof window === 'undefined' || !window.Sentry) return;
                try {
                    if (id) {
                        window.Sentry.setUser({
                            id: id,
                            username: username || null,
                            walletAddress: walletAddress || null,
                        });
                    } else {
                        window.Sentry.setUser(null);
                    }
                } catch (e) {}
            }
            ,
        'io.ioda.one.platformShare' : 
        function(text) {
            if (navigator.share) {
                navigator.share({ text: text }).catch(function() {});
            } else {
                navigator.clipboard.writeText(text);
            }
        }
        ,
        'io.ioda.one.hardware.jsReadNFC' : 
        function() {
            return new Promise(function(resolve, reject) {
                if (!('NDEFReader' in window)) {
                    reject(new Error('Web NFC not available'));
                    return;
                }
                try {
                    var reader = new NDEFReader();
                    reader.scan().then(function() {
                        reader.onreading = function(event) {
                            var message = event.message;
                            for (var i = 0; i < message.records.length; i++) {
                                var record = message.records[i];
                                if (record.recordType === 'url' || record.recordType === 'text') {
                                    var decoder = new TextDecoder();
                                    var text = decoder.decode(record.data);
                                    resolve(text);
                                    return;
                                }
                            }
                            resolve('');
                        };
                        reader.onreadingerror = function() {
                            reject(new Error('NFC read error'));
                        };
                    }).catch(reject);
                } catch(e) {
                    reject(e);
                }
            });
        }
        ,
        'io.ioda.one.hardware.jsNFCAvailable' : 
        function() {
            return typeof window !== 'undefined' && 'NDEFReader' in window;
        }
        ,
        'io.ioda.one.hardware.jsScanQR' : 
        function() {
            return new Promise(function(resolve, reject) {
                if (!navigator.mediaDevices) { reject(new Error('Camera not available')); return; }
        
                var video = document.createElement('video');
                video.setAttribute('playsinline', '');
                video.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:99999;object-fit:cover;background:#000';
        
                var canvas = document.createElement('canvas');
                var ctx2d = canvas.getContext('2d');
        
                var closeBtn = document.createElement('button');
                closeBtn.textContent = 'Cancel';
                closeBtn.style.cssText = 'position:fixed;top:env(safe-area-inset-top,20px);right:20px;z-index:100000;padding:12px 24px;background:rgba(0,0,0,0.7);color:#fff;border:1px solid rgba(255,255,255,0.3);border-radius:12px;font-size:16px;cursor:pointer;backdrop-filter:blur(10px);margin-top:20px';
        
                document.body.appendChild(video);
                document.body.appendChild(closeBtn);
        
                var stream = null;
                var scanning = true;
                var jsQRLoaded = typeof window.jsQR === 'function';
                var useBarcodeDetector = typeof BarcodeDetector !== 'undefined';
        
                function cleanup() {
                    scanning = false;
                    if (stream) stream.getTracks().forEach(function(t) { t.stop(); });
                    if (video.parentNode) video.parentNode.removeChild(video);
                    if (closeBtn.parentNode) closeBtn.parentNode.removeChild(closeBtn);
                }
        
                closeBtn.onclick = function() { cleanup(); resolve(''); };
        
                function loadJsQR(cb) {
                    if (typeof window.jsQR === 'function') { cb(); return; }
                    var s = document.createElement('script');
                    s.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.min.js';
                    s.onload = function() { cb(); };
                    s.onerror = function() { reject(new Error('Failed to load QR scanner')); cleanup(); };
                    document.head.appendChild(s);
                }
        
                function scanWithJsQR() {
                    if (!scanning) return;
                    if (video.readyState !== video.HAVE_ENOUGH_DATA) {
                        requestAnimationFrame(scanWithJsQR);
                        return;
                    }
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    ctx2d.drawImage(video, 0, 0, canvas.width, canvas.height);
                    var imageData = ctx2d.getImageData(0, 0, canvas.width, canvas.height);
                    var code = window.jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: 'dontInvert' });
                    if (code && code.data) {
                        cleanup();
                        resolve(code.data);
                    } else {
                        requestAnimationFrame(scanWithJsQR);
                    }
                }
        
                function scanWithBarcodeDetector(detector) {
                    if (!scanning) return;
                    detector.detect(video).then(function(barcodes) {
                        if (barcodes.length > 0) {
                            cleanup();
                            resolve(barcodes[0].rawValue);
                        } else {
                            requestAnimationFrame(function() { scanWithBarcodeDetector(detector); });
                        }
                    }).catch(function() {
                        requestAnimationFrame(function() { scanWithBarcodeDetector(detector); });
                    });
                }
        
                navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
                    .then(function(s) {
                        stream = s;
                        video.srcObject = s;
                        video.play();
                        video.onloadedmetadata = function() {
                            if (useBarcodeDetector) {
                                var detector = new BarcodeDetector({ formats: ['qr_code'] });
                                scanWithBarcodeDetector(detector);
                            } else {
                                loadJsQR(function() { scanWithJsQR(); });
                            }
                        };
                    })
                    .catch(function(err) {
                        cleanup();
                        reject(err);
                    });
            });
        }
        ,
        'io.ioda.one.hardware.jsQRAvailable' : 
        function() {
            return typeof window !== 'undefined' && typeof navigator.mediaDevices !== 'undefined';
        }
        ,
        'io.ioda.one.notifications.isWebPushAvailable' : () => typeof window !== 'undefined' && 'Notification' in window && 'PushManager' in window && 'serviceWorker' in navigator,
        'io.ioda.one.notifications.jsRegisterPush' : (cb) => { if (typeof window.iodaRegisterPush === 'function') { window.iodaRegisterPush().then(t => cb(t || null)).catch(() => cb(null)); } else { cb(null); } },
        'io.ioda.one.notifications.__convertKotlinClosureToJsClosure_((String?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String?)->Unit)'](f, p0)),
        'io.ioda.one.runtime.lsGet' : function(key) { try { return localStorage.getItem(key) || ''; } catch(e) { return ''; } },
        'io.ioda.one.runtime.lsSet' : function(key, value) { try { localStorage.setItem(key, value); } catch(e) {} },
        'io.ioda.one.runtime.lsClearPrefix' : function(prefix) { try { var keys = []; for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf(prefix) === 0) keys.push(k); } keys.forEach(function(k) { localStorage.removeItem(k); }); } catch(e) {} },
        'io.ioda.one.runtime.lsSizePrefix' : 
        function(prefix) {
            try {
                var total = 0;
                for (var i = 0; i < localStorage.length; i++) {
                    var k = localStorage.key(i);
                    if (k && k.indexOf(prefix) === 0) {
                        var v = localStorage.getItem(k) || '';
                        total += k.length * 2 + v.length * 2;
                    }
                }
                return total;
            } catch(e) { return 0; }
        }
        ,
        'io.ioda.one.runtime.lsAppIds' : 
        function(prefix) {
            try {
                var ids = {};
                for (var i = 0; i < localStorage.length; i++) {
                    var k = localStorage.key(i);
                    if (k && k.indexOf(prefix) === 0) {
                        var rest = k.substring(prefix.length);
                        var appId = rest.split(':')[0];
                        if (appId) ids[appId] = true;
                    }
                }
                return Object.keys(ids).join(',');
            } catch(e) { return ''; }
        }
        ,
        'io.ioda.one.runtime.engine.createContext' : 
        function(appId) {
            if (!window.__iodaCartridges) window.__iodaCartridges = {};
            window.__iodaCartridges[appId] = {
                state: {},
                lists: {},
                currentScreen: null,
                toast: null,
                _onAction: null,
                _pendingCalls: [],
                _pendingCallbacks: {},
                _callIdCounter: 0
            };
            return appId;
        }
        ,
        'io.ioda.one.runtime.engine.evalScript' : 
        function(appId, source) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) throw new Error('No context for ' + appId);
        
            var bridge = {
                setState: function(key, value) {
                    ctx.state[key] = String(value);
                },
                getState: function(key) {
                    return ctx.state[key] || '';
                },
                setList: function(key, items) {
                    ctx.lists[key] = items;
                },
                navigate: function(screen) {
                    ctx.currentScreen = screen;
                },
                toast: function(message) {
                    ctx.toast = message;
                },
                walletAddress: function() {
                    return ctx.state['__walletAddress'] || '';
                },
                walletUsername: function() {
                    return ctx.state['__walletUsername'] || '';
                },
                iodaId: function() {
                    return ctx.state['__iodaId'] || '';
                },
                setDrawCommands: function(canvasId, commands) {
                    ctx['_canvas_' + canvasId + '_drawCommands'] = commands;
                },
                canvasWidth: function() { return ctx._canvasWidth || 0; },
                canvasHeight: function() { return ctx._canvasHeight || 0; },
                clipboard: function(text) {
                    if (navigator && navigator.clipboard) navigator.clipboard.writeText(text);
                },
                hasCamera: function() {
                    return typeof navigator.mediaDevices !== 'undefined' && typeof navigator.mediaDevices.getUserMedia === 'function';
                },
                hasNFC: function() {
                    return typeof window !== 'undefined' && 'NDEFReader' in window;
                },
                // Web Bluetooth can only act as central (scanner), and only on
                // Chrome/Edge/Opera. Even where it works, it cannot advertise as a
                // peripheral, so iodaPay's tap-to-pay round-trip is impossible.
                // Hide the button entirely on web — users get the mobile-app prompt.
                hasBLE: function() { return false; },
                call: function(method, params, callback) {
                    var callId = '__cb_' + (++ctx._callIdCounter);
                    if (callback) ctx._pendingCallbacks[callId] = callback;
                    ctx._pendingCalls.push(JSON.stringify({ id: callId, method: method, params: params || {} }));
                }
            };
        
            var wrappedSource = '(function(bridge, ctx) {' + source + '})';
            var factory = (0, eval)(wrappedSource);
            factory(bridge, ctx);
        
            return 'ok';
        }
        ,
        'io.ioda.one.runtime.engine.jsDispatchAction' : 
        function(appId, actionName, data) {
            return new Promise(function(resolve, reject) {
                try {
                    var ctx = window.__iodaCartridges[appId];
                    if (!ctx) { reject(new Error('No context')); return; }
                    if (typeof ctx._onAction === 'function') {
                        var result = ctx._onAction(actionName, data);
                        if (result && typeof result.then === 'function') {
                            result.then(function() { resolve('ok'); }, reject);
                        } else {
                            resolve('ok');
                        }
                    } else {
                        resolve('no_handler');
                    }
                } catch(e) {
                    reject(e);
                }
            });
        }
        ,
        'io.ioda.one.runtime.engine.jsReadState' : 
        function(appId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return '{}';
            return JSON.stringify(ctx.state);
        }
        ,
        'io.ioda.one.runtime.engine.jsReadLists' : 
        function(appId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return '{}';
            return JSON.stringify(ctx.lists);
        }
        ,
        'io.ioda.one.runtime.engine.jsReadCurrentScreen' : 
        function(appId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return '';
            return ctx.currentScreen || '';
        }
        ,
        'io.ioda.one.runtime.engine.jsReadToast' : 
        function(appId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return '';
            var msg = ctx.toast || '';
            ctx.toast = null;
            return msg;
        }
        ,
        'io.ioda.one.runtime.engine.jsSetCurrentScreen' : 
        function(appId, screen) {
            var ctx = window.__iodaCartridges[appId];
            if (ctx) ctx.currentScreen = screen;
        }
        ,
        'io.ioda.one.runtime.engine.jsDestroyContext' : 
        function(appId) {
            if (window.__iodaCartridges) {
                delete window.__iodaCartridges[appId];
            }
        }
        ,
        'io.ioda.one.runtime.engine.jsInjectState' : 
        function(appId, key, value) {
            var ctx = window.__iodaCartridges[appId];
            if (ctx) {
                ctx.state[key] = value;
                if (typeof ctx._onStateChange === 'function') ctx._onStateChange(key, value);
            }
        }
        ,
        'io.ioda.one.runtime.engine.jsCallOnFrame' : 
        function(appId, canvasId, timestamp, width, height) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return;
            ctx._canvasWidth = width;
            ctx._canvasHeight = height;
            if (typeof ctx._onFrame === 'function') {
                ctx._onFrame(canvasId, timestamp);
            }
        }
        ,
        'io.ioda.one.runtime.engine.jsReadDrawCommands' : 
        function(appId, canvasId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return '[]';
            var key = '_canvas_' + canvasId + '_drawCommands';
            var cmds = ctx[key];
            if (!cmds || !cmds.length) return '[]';
            return JSON.stringify(cmds);
        }
        ,
        'io.ioda.one.runtime.engine.jsDispatchInputEvent' : 
        function(appId, canvasId, eventType, x, y, extra) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return;
            if (typeof ctx._onInput === 'function') {
                ctx._onInput(canvasId, eventType, x, y, extra);
            }
        }
        ,
        'io.ioda.one.runtime.engine.jsReadPendingCall' : 
        function(appId) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx || !ctx._pendingCalls || ctx._pendingCalls.length === 0) return '';
            return ctx._pendingCalls.shift();
        }
        ,
        'io.ioda.one.runtime.engine.jsResolveCall' : 
        function(appId, callId, resultJson) {
            var ctx = window.__iodaCartridges[appId];
            if (!ctx) return;
            var cb = ctx._pendingCallbacks[callId];
            if (typeof cb === 'function') {
                try { cb(JSON.parse(resultJson)); } catch(e) {}
                delete ctx._pendingCallbacks[callId];
            }
        }
        ,
        'io.ioda.one.runtime.renderer.createPdfView' : 
        function(url, containerId) {
            var existing = document.getElementById(containerId);
            if (existing) return;
        
            // Container div clips PDF below header — nothing escapes upward
            var headerHeight = 48;
            var container = document.createElement('div');
            container.id = containerId;
            container.style.cssText = 'position:fixed;top:' + headerHeight + 'px;left:0;width:100%;height:calc(100% - ' + headerHeight + 'px);overflow:hidden;z-index:1;';
            var iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.cssText = 'width:100%;height:100%;border:none;background:#ffffff;';
            container.appendChild(iframe);
            document.body.appendChild(container);
        }
        ,
        'io.ioda.one.runtime.renderer.removePdfView' : 
        function(containerId) {
            var el = document.getElementById(containerId);
            if (el) el.remove();
        }
        ,
        'io.ioda.one.runtime.renderer.createGameView' : 
        function(url, containerId) {
            var existing = document.getElementById(containerId);
            if (existing) return;
        
            var iframe = document.createElement('iframe');
            iframe.id = containerId;
            iframe.src = url;
            iframe.style.cssText = 'position:fixed;top:48px;left:0;width:100%;height:calc(100% - 48px);border:none;z-index:999;background:#0A0A0A;';
            iframe.setAttribute('allow', 'autoplay; fullscreen; web-share');
            document.body.appendChild(iframe);
        }
        ,
        'io.ioda.one.runtime.renderer.removeGameView' : 
        function(containerId) {
            var el = document.getElementById(containerId);
            if (el) el.remove();
        }
        ,
        'io.ioda.one.stealth.jsGenerateEphemeral' : 
        function() {
            return (async function() {
                try {
                    var x = await import('@noble/curves/ed25519');
                    var priv = x.x25519.utils.randomPrivateKey();
                    var pub = x.x25519.getPublicKey(priv);
                    var hex = '';
                    for (var i = 0; i < pub.length; i++) hex += ('0' + pub[i].toString(16)).slice(-2);
                    for (var j = 0; j < priv.length; j++) hex += ('0' + priv[j].toString(16)).slice(-2);
                    return hex;
                } catch (e) {
                    console.error('stealth ephemeral failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsStealthSeal' : 
        function(plainHex, recipientPubHex, ephemeralPrivHex, viewTag) {
            return (async function() {
                try {
                    var x = await import('@noble/curves/ed25519');
                    var ciphersMod = await import('@noble/ciphers/chacha');
                    var hashes = await import('@noble/hashes/hkdf');
                    var sha256 = await import('@noble/hashes/sha256');
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var pt = hex(plainHex);
                    var recipientPub = hex(recipientPubHex);
                    var ephemeralPriv = hex(ephemeralPrivHex);
                    var shared = x.x25519.getSharedSecret(ephemeralPriv, recipientPub);
                    var info = new TextEncoder().encode('ioda-stealth-chachapoly-v2');
                    var key = hashes.hkdf(sha256.sha256, shared, undefined, info, 32);
                    var nonce = new Uint8Array(12);
                    window.crypto.getRandomValues(nonce);
                    var chacha = ciphersMod.chacha20poly1305(key, nonce);
                    var ct = chacha.encrypt(pt);
                    // Wire format: [viewTag(1) || nonce(12) || ciphertext_with_tag]
                    var out = new Uint8Array(1 + nonce.length + ct.length);
                    out[0] = viewTag & 0xFF;
                    out.set(nonce, 1);
                    out.set(ct, 1 + nonce.length);
                    return bytes2hex(out);
                } catch (e) {
                    console.error('stealth seal failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsStealthOpen' : 
        function(ephemeralPubHex, viewingPrivHex, blobHex) {
            return (async function() {
                try {
                    var x = await import('@noble/curves/ed25519');
                    var ciphersMod = await import('@noble/ciphers/chacha');
                    var hashes = await import('@noble/hashes/hkdf');
                    var sha256 = await import('@noble/hashes/sha256');
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var ephemeralPub = hex(ephemeralPubHex);
                    var viewingPriv = hex(viewingPrivHex);
                    var blob = hex(blobHex);
                    if (blob.length < 1 + 12 + 16) return '__ERROR__';
                    var nonce = blob.slice(1, 13);
                    var ct = blob.slice(13);
                    var shared = x.x25519.getSharedSecret(viewingPriv, ephemeralPub);
                    var info = new TextEncoder().encode('ioda-stealth-chachapoly-v2');
                    var key = hashes.hkdf(sha256.sha256, shared, undefined, info, 32);
                    var chacha = ciphersMod.chacha20poly1305(key, nonce);
                    var pt = chacha.decrypt(ct);
                    return bytes2hex(pt);
                } catch (e) {
                    console.error('stealth open failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsDeriveStealthKeypair' : 
        function(viewingPrivHex, ephemeralPubHex) {
            return (async function() {
                try {
                    var x = await import('@noble/curves/ed25519');
                    var hashes = await import('@noble/hashes/hkdf');
                    var sha256 = await import('@noble/hashes/sha256');
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var viewingPriv = hex(viewingPrivHex);
                    var ephemeralPub = hex(ephemeralPubHex);
                    var shared = x.x25519.getSharedSecret(viewingPriv, ephemeralPub);
                    var info = new TextEncoder().encode('ioda-stealth-address-v2');
                    var seed = hashes.hkdf(sha256.sha256, shared, undefined, info, 32);
                    // Derive ed25519 public key from seed via noble's getPublicKey,
                    // which is the same operation Tink and CryptoKit perform on the
                    // other platforms — both sides compute the same shared secret
                    // and therefore the same stealth keypair.
                    var pub = x.ed25519.getPublicKey(seed);
                    return bytes2hex(seed) + bytes2hex(pub);
                } catch (e) {
                    console.error('stealth derive keypair failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsEd25519Sign' : 
        function(messageHex, seedHex) {
            return (async function() {
                try {
                    var ed = await import('@noble/ed25519');
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var msg = hex(messageHex);
                    var seed = hex(seedHex);
                    var sig = await ed.signAsync(msg, seed);
                    return bytes2hex(sig);
                } catch (e) {
                    console.error('ed25519 sign failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsHasStealthKeys' : 
        function() {
            return window.localStorage.getItem('ioda_stealth_keys_ct') !== null;
        }
        ,
        'io.ioda.one.stealth.jsSaveStealthKeys' : 
        function(packedHex, passphrase) {
            return (async function() {
                try {
                    var ciphersMod = await import('@noble/ciphers/chacha');
                    var hashes = await import('@noble/hashes/scrypt');
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var packed = hex(packedHex);
                    var salt = new Uint8Array(16);
                    window.crypto.getRandomValues(salt);
                    var pwBytes = new TextEncoder().encode(passphrase);
                    var key = hashes.scrypt(pwBytes, salt, { N: 32768, r: 8, p: 1, dkLen: 32 });
                    var nonce = new Uint8Array(12);
                    window.crypto.getRandomValues(nonce);
                    var chacha = ciphersMod.chacha20poly1305(key, nonce);
                    var ct = chacha.encrypt(packed);
                    var combined = new Uint8Array(nonce.length + ct.length);
                    combined.set(nonce, 0);
                    combined.set(ct, nonce.length);
                    window.localStorage.setItem('ioda_stealth_keys_ct', bytes2hex(combined));
                    window.localStorage.setItem('ioda_stealth_keys_salt', bytes2hex(salt));
                    return null;
                } catch (e) {
                    console.error('Stealth save failed:', e);
                    return null;
                }
            })();
        }
        ,
        'io.ioda.one.stealth.jsLoadStealthKeys' : 
        function(passphrase) {
            return (async function() {
                try {
                    var combinedHex = window.localStorage.getItem('ioda_stealth_keys_ct');
                    var saltHex = window.localStorage.getItem('ioda_stealth_keys_salt');
                    if (!combinedHex || !saltHex) return '__ERROR__';
                    var ciphersMod = await import('@noble/ciphers/chacha');
                    var hashes = await import('@noble/hashes/scrypt');
                    function hex(s) {
                        var out = new Uint8Array(s.length / 2);
                        for (var i = 0; i < out.length; i++) out[i] = parseInt(s.substr(i * 2, 2), 16);
                        return out;
                    }
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    var combined = hex(combinedHex);
                    var salt = hex(saltHex);
                    var nonce = combined.slice(0, 12);
                    var ct = combined.slice(12);
                    var pwBytes = new TextEncoder().encode(passphrase);
                    var key = hashes.scrypt(pwBytes, salt, { N: 32768, r: 8, p: 1, dkLen: 32 });
                    var chacha = ciphersMod.chacha20poly1305(key, nonce);
                    var pt = chacha.decrypt(ct);
                    return bytes2hex(pt);
                } catch (e) {
                    console.error('Stealth load failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsManagedReadPubkey' : function() { return window.localStorage.getItem('ioda_solana_managed_pubkey'); },
        'io.ioda.one.wallet.jsSetActiveUser' : 
        function(iodaId) {
            window.__ioda_active_iodaid = iodaId;
        }
        ,
        'io.ioda.one.wallet.jsClearEntropyBlob' : function() { var u = window.__ioda_active_iodaid || ''; var k = u ? 'ioda_device_entropy_blob_' + u : 'ioda_device_entropy_blob'; window.localStorage.removeItem(k); },
        'io.ioda.one.wallet.jsClearEntropyPbkdf2Salt' : function() { var u = window.__ioda_active_iodaid || ''; var k = u ? 'ioda_device_entropy_pbkdf2_salt_' + u : 'ioda_device_entropy_pbkdf2_salt'; window.localStorage.removeItem(k); },
        'io.ioda.one.wallet.jsClearEntropyGcmIv' : function() { var u = window.__ioda_active_iodaid || ''; var k = u ? 'ioda_device_entropy_gcm_iv_' + u : 'ioda_device_entropy_gcm_iv'; window.localStorage.removeItem(k); },
        'io.ioda.one.wallet.jsHasDeviceEntropy' : function() { var u = window.__ioda_active_iodaid || ''; var k = u ? 'ioda_device_entropy_blob_' + u : 'ioda_device_entropy_blob'; return window.localStorage.getItem(k) !== null; },
        'io.ioda.one.wallet.jsIsUnlocked' : function() { return (window.__iodaEntropy || null) !== null; },
        'io.ioda.one.wallet.jsSetupPin' : 
        function(pin, iodaId) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    var ed = await import('@noble/ed25519');
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    var entropy = window.crypto.getRandomValues(new Uint8Array(32));
                    var enc = await __pinEncrypt(pin, entropy);
                    window.localStorage.setItem(__ek('ioda_device_entropy_blob'), __b64(enc.ct));
                    window.localStorage.setItem(__ek('ioda_device_entropy_pbkdf2_salt'), __b64(enc.pbkdf2Salt));
                    window.localStorage.setItem(__ek('ioda_device_entropy_gcm_iv'), __b64(enc.iv));
                    window.__iodaEntropy = entropy;
                    var seed = await __hkdfSeedV2(iodaId, 'ioda-solana-keypair-v2', entropy);
                    var pubkey = await ed.getPublicKeyAsync(seed);
                    return __base58(pubkey);
                } catch (e) {
                    console.error('setupPin failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsManagedStoreSession' : 
        function(iodaId, pubkey) {
            window.localStorage.setItem('ioda_solana_managed_pubkey', pubkey);
            window.localStorage.setItem('ioda_solana_managed_iodaid', iodaId);
        }
        ,
        'io.ioda.one.wallet.jsUnlockWithPin' : 
        function(pin) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    var entropy = await __pinDecrypt(pin);
                    if (!entropy || entropy.length !== 32) return 'false';
                    window.__iodaEntropy = entropy;
                    return 'true';
                } catch (e) {
                    console.error('unlockWithPin failed:', e);
                    return 'false';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsChangePin' : 
        function(currentPin, newPin) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    var entropy = await __pinDecrypt(currentPin);
                    if (!entropy || entropy.length !== 32) return 'false';
                    var enc = await __pinEncrypt(newPin, entropy);
                    window.localStorage.setItem(__ek('ioda_device_entropy_blob'), __b64(enc.ct));
                    window.localStorage.setItem(__ek('ioda_device_entropy_pbkdf2_salt'), __b64(enc.pbkdf2Salt));
                    window.localStorage.setItem(__ek('ioda_device_entropy_gcm_iv'), __b64(enc.iv));
                    return 'true';
                } catch (e) {
                    console.error('changePin failed:', e);
                    return 'false';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsGetEntropyForEscrow' : 
        function() {
            if (!window.__iodaEntropy) return null;
            return btoa(String.fromCharCode.apply(null, window.__iodaEntropy));
        }
        ,
        'io.ioda.one.wallet.jsRecoverFromEscrow' : 
        function(entropyBase64, newPin, iodaId) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    var ed = await import('@noble/ed25519');
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    var entropy = Uint8Array.from(atob(entropyBase64), function(c) { return c.charCodeAt(0); });
                    if (entropy.length !== 32) return '__ERROR__';
                    var enc = await __pinEncrypt(newPin, entropy);
                    window.localStorage.setItem(__ek('ioda_device_entropy_blob'), __b64(enc.ct));
                    window.localStorage.setItem(__ek('ioda_device_entropy_pbkdf2_salt'), __b64(enc.pbkdf2Salt));
                    window.localStorage.setItem(__ek('ioda_device_entropy_gcm_iv'), __b64(enc.iv));
                    window.__iodaEntropy = entropy;
                    var seed = await __hkdfSeedV2(iodaId, 'ioda-solana-keypair-v2', entropy);
                    var pubkey = await ed.getPublicKeyAsync(seed);
                    return __base58(pubkey);
                } catch (e) {
                    console.error('recoverFromEscrow failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsDeriveSigningKeyV2' : 
        function(iodaId) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    if (!window.__iodaEntropy) return '__ERROR__';
                    var ed = await import('@noble/ed25519');
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    var seed = await __hkdfSeedV2(iodaId, 'ioda-solana-keypair-v2', window.__iodaEntropy);
                    var pubkey = await ed.getPublicKeyAsync(seed);
                    return __base58(pubkey);
                } catch (e) {
                    console.error('deriveSigningKeyV2 failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsSignTransactionV2' : 
        function(iodaId, txHex) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    if (!window.__iodaEntropy) return '__ERROR__';
                    var ed = await import('@noble/ed25519');
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    var seed = await __hkdfSeedV2(iodaId, 'ioda-solana-keypair-v2', window.__iodaEntropy);
                    var tx = new Uint8Array(txHex.match(/.{2}/g).map(function(b) { return parseInt(b, 16); }));
                    var sig = await ed.signAsync(tx, seed);
                    var hex = '';
                    for (var i = 0; i < sig.length; i++) {
                        hex += ('0' + sig[i].toString(16)).slice(-2);
                    }
                    return hex;
                } catch (e) {
                    console.error('signTransactionV2 failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsClearSession' : 
        function() {
            window.__iodaEntropy = null;
            window.localStorage.removeItem('ioda_solana_managed_pubkey');
            window.localStorage.removeItem('ioda_solana_managed_iodaid');
        }
        ,
        'io.ioda.one.wallet.jsDeriveSiblingKeyV2' : 
        function(iodaId, info) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    if (!window.__iodaEntropy) return '__ERROR__';
                    var seed = await __hkdfSeedV2(iodaId, info, window.__iodaEntropy);
                    return __base58(seed);
                } catch (e) {
                    console.error('deriveSiblingKeyV2 failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsDeriveFullStealthKeys' : 
        function(iodaId) {
            return (async function() {
                try {
            
        var __iodaEntropy = window.__iodaEntropy || null;
        var DETERMINISTIC_SALT = 
        new Uint8Array([
            0x36, 0x7d, 0xf9, 0x0c, 0xfa, 0xa9, 0x67, 0xa5,
            0x8c, 0x18, 0x39, 0x29, 0xc2, 0x83, 0x82, 0xc9,
            0xac, 0x6f, 0xb6, 0xa5, 0xa0, 0x0e, 0xaa, 0xb8,
            0xe6, 0x15, 0x4a, 0x06, 0x1a, 0xa1, 0x6a, 0x58
        ])
        ;
        var PBKDF2_ITERATIONS = 600000;
        var __uid = window.__ioda_active_iodaid || '';
        
        function __ek(base) { return __uid ? base + '_' + __uid : base; }
        
        async function __combinedSalt(entropy) {
            var combined = new Uint8Array(32 + 32);
            combined.set(DETERMINISTIC_SALT, 0);
            combined.set(entropy, 32);
            var hash = await window.crypto.subtle.digest('SHA-256', combined);
            return new Uint8Array(hash);
        }
        
        async function __pbkdf2Key(pin) {
            var enc = new TextEncoder();
            return await window.crypto.subtle.importKey(
                'raw', enc.encode(pin), 'PBKDF2', false, ['deriveBits', 'deriveKey']
            );
        }
        
        async function __pinEncrypt(pin, entropy) {
            var pinKey = await __pbkdf2Key(pin);
            var pbkdf2Salt = window.crypto.getRandomValues(new Uint8Array(16));
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            );
            var iv = window.crypto.getRandomValues(new Uint8Array(12));
            var ct = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, entropy);
            return { ct: new Uint8Array(ct), iv: iv, pbkdf2Salt: pbkdf2Salt };
        }
        
        async function __pinDecrypt(pin) {
            var blobB64 = window.localStorage.getItem(__ek('ioda_device_entropy_blob'));
            var saltB64 = window.localStorage.getItem(__ek('ioda_device_entropy_pbkdf2_salt'));
            var ivB64 = window.localStorage.getItem(__ek('ioda_device_entropy_gcm_iv'));
            if (!blobB64 || !saltB64 || !ivB64) return null;
            var ct = Uint8Array.from(atob(blobB64), function(c) { return c.charCodeAt(0); });
            var pbkdf2Salt = Uint8Array.from(atob(saltB64), function(c) { return c.charCodeAt(0); });
            var iv = Uint8Array.from(atob(ivB64), function(c) { return c.charCodeAt(0); });
            var pinKey = await __pbkdf2Key(pin);
            var aesKey = await window.crypto.subtle.deriveKey(
                { name: 'PBKDF2', hash: 'SHA-256', salt: pbkdf2Salt, iterations: PBKDF2_ITERATIONS },
                pinKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
            );
            try {
                var plain = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, aesKey, ct);
                return new Uint8Array(plain);
            } catch (e) { return null; }
        }
        
        function __b64(arr) { return btoa(String.fromCharCode.apply(null, arr)); }
        
        function __base58(bytes) {
            var alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            var input = Array.from(bytes);
            var leadingZeros = 0;
            while (leadingZeros < input.length && input[leadingZeros] === 0) leadingZeros++;
            var encoded = '';
            var start = leadingZeros;
            while (start < input.length) {
                var remainder = 0;
                for (var i = start; i < input.length; i++) {
                    var num = input[i] + remainder * 256;
                    input[i] = Math.floor(num / 58);
                    remainder = num % 58;
                }
                if (input[start] === 0) start++;
                encoded = alphabet[remainder] + encoded;
            }
            for (var z = 0; z < leadingZeros; z++) encoded = alphabet[0] + encoded;
            return encoded;
        }
        
        async function __hkdfSeedV2(iodaId, info, entropy) {
            var salt = await __combinedSalt(entropy);
            var enc = new TextEncoder();
            var ikm = enc.encode(iodaId);
            var key = await window.crypto.subtle.importKey('raw', ikm, 'HKDF', false, ['deriveBits']);
            var seedBuf = await window.crypto.subtle.deriveBits(
                { name: 'HKDF', hash: 'SHA-256', salt: salt, info: enc.encode(info) },
                key, 256
            );
            return new Uint8Array(seedBuf);
        }
        
                    if (!window.__iodaEntropy) return '__ERROR__';
                    var ed = await import('@noble/ed25519');
                    var x = await import('@noble/curves/ed25519');
                    // Viewing key: X25519 from HKDF(iodaId, "ioda-stealth-v2")
                    var viewSeed = await __hkdfSeedV2(iodaId, 'ioda-stealth-v2', window.__iodaEntropy);
                    var viewPriv = viewSeed;
                    var viewPub = x.x25519.getPublicKey(viewPriv);
                    // Spending key: ed25519 from HKDF(iodaId, "ioda-stealth-spending-v2")
                    var spendSeed = await __hkdfSeedV2(iodaId, 'ioda-stealth-spending-v2', window.__iodaEntropy);
                    var sha512Mod = await import('@noble/hashes/sha512');
                    ed.etc.sha512Sync = function() {
                        var concat = ed.etc.concatBytes.apply(null, arguments);
                        return sha512Mod.sha512(concat);
                    };
                    var spendPub = await ed.getPublicKeyAsync(spendSeed);
                    function bytes2hex(b) {
                        var s = '';
                        for (var i = 0; i < b.length; i++) s += ('0' + b[i].toString(16)).slice(-2);
                        return s;
                    }
                    return bytes2hex(spendSeed) + bytes2hex(spendPub) + bytes2hex(viewPriv) + bytes2hex(viewPub);
                } catch (e) {
                    console.error('deriveFullStealthKeys failed:', e);
                    return '__ERROR__';
                }
            })();
        }
        ,
        'io.ioda.one.wallet.jsManagedReadIodaId' : function() { return window.localStorage.getItem('ioda_solana_managed_iodaid'); }
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }
    
    const wasmFilePath = './ioda-one-composeApp-wasm-js.wasm';
    const importObject = {
        js_code,
        intrinsics: {
            
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./ioda-one-composeApp-wasm-js.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
